import React from 'react';
import '../styles/app-bootstrap.css';

function AppSplashScreen({ progress = 0, message = 'Dein Spielstand wird geladen …', error = null, onRetry }) {
  const safeProgress = Math.max(0, Math.min(100, Number(progress || 0)));

  return (
    <div className="pfp-app-splash" role="status" aria-live="polite">
      <div className="pfp-app-splash__card">
        <div className="pfp-app-splash__logo" aria-hidden="true">☠️</div>
        <div className="pfp-app-splash__kicker">Pfandpirat</div>
        <h1 className="pfp-app-splash__title">Spielstand wird geladen</h1>
        <p className="pfp-app-splash__message">{message}</p>

        <div className="pfp-app-splash__bar" aria-label="Ladefortschritt">
          <div
            className="pfp-app-splash__bar-fill"
            style={{ width: `${safeProgress}%` }}
          />
        </div>

        <div className="pfp-app-splash__progress">{Math.round(safeProgress)} %</div>

        {error ? (
          <div className="pfp-app-splash__error">
            <p>{error.message || 'Der Server hat den Spielstand nicht geliefert.'}</p>
            <button type="button" className="pfp-app-splash__button" onClick={onRetry}>
              Erneut versuchen
            </button>
          </div>
        ) : null}

        <p className="pfp-app-splash__hint">
          Server bleibt führend. Der Spielstand wird nur temporär für diese Sitzung vorgeladen.
        </p>
      </div>
    </div>
  );
}

export default AppSplashScreen;
